var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import ReactPlayer from 'react-player';
import styled from 'styled-components';
var PlayerWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 200px;\n\n  @media (min-width: 768px) {\n    height: 400px;\n  }\n"], ["\n  height: 200px;\n\n  @media (min-width: 768px) {\n    height: 400px;\n  }\n"])));
export default function VideoPlayer(props) {
    return (_jsx(PlayerWrapper, { children: _jsx(ReactPlayer, { url: props.url, onReady: function (player) {
                if (props.startAt) {
                    player.seekTo(props.startAt);
                }
            }, onProgress: function (played) {
                if (props.onProgress) {
                    props.onProgress(played.playedSeconds);
                }
            }, width: "100%", height: "100%", controls: true, playsinline: true, onPlay: props.onPlay }, void 0) }, void 0));
}
var templateObject_1;
//# sourceMappingURL=VideoPlayer.js.map